import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Markdown from 'react-markdown';
import utils from 'Utils';
import * as styles from './tooltipView.css';
import * as buttonStyles from '../../styles/buttons.css';
import * as iconStyles from '../../styles/icons.css';

const { mapKV } = utils.obj;

export class TooltipView extends Component {
  static renderItems(items) {
    return items.map((item) =>
      <li key={item}>
        <Markdown
          source={item}
          renderers={{ link: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ) }}
        />
      </li>
    );
  }

  constructor(props) {
    super(props);

    // Render
    this.renderContent = this.renderContent.bind(this);

    // Events
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.close = this.close.bind(this);

    // Setups
    this.documentBody = document.querySelector('body');
  }

  componentDidMount() {
    // Save the parent
    this.parent = this.tooltip.parentNode;
    // Now move this to body
    this.documentBody.appendChild(this.tooltip);
    const { innerHeight, innerWidth } = window;
    const { width, height } = this.tooltipContent.getBoundingClientRect();

    this.tooltipContent.style.top = `${(innerHeight - height) / 2}px`;
    this.tooltipContent.style.left = `${(innerWidth - width) / 2}px`;
    this.documentBody.classList.add(styles.lockBody);

    // Set open in new window on anchors
    // This breaks in IE11 so lets ignore it if IE11
    if (!(!!window.MSInputMethodContext && !!document.documentMode)) {
      this.tooltipContent.querySelectorAll('a').forEach((anchor) => {
        anchor.setAttribute('target', '_blank');
        anchor.setAttribute('rel', 'noopener noreferrer');
      });
    }
  }

  componentWillUnmount() {
    // Move back to the parent
    this.parent.appendChild(this.tooltip);
    this.documentBody.classList.remove(styles.lockBody);
  }

  close(e) {
    if (e.target === this.tooltip) {
      this.props.onClose();
    }
  }

  renderContent() {
    const { content } = this.props;
    if (Array.isArray(content)) {
      const className = 1 < content.length ? 'items' : 'item';
      return (
        <ol className={styles[className]}>
          {TooltipView.renderItems(content)}
        </ol>
      );
    }
    // If an object
    return mapKV(content, (items, key) => {
      const className = 1 < content.length ? 'items' : 'item';
      return (
        <dl key={key} className={styles.dlist}>
          <dt>{key}</dt>
          <dd>
            <ol className={styles[className]}>
              {TooltipView.renderItems(items)}
            </ol>
          </dd>
        </dl>
      );
    }, true);
  }

  render() {
    // Disabling this for wrapper interactions
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (
      <span className={styles.wrapper} ref={(ref) => { this.anchor = ref; }}>
        <div
          className={styles.tooltipBack}
          ref={(ref) => { this.tooltip = ref; }}
          onClick={this.close}
        >
          <div
            ref={(ref) => { this.tooltipContent = ref; }}
            className={styles.tooltip}
          >
            <div className={styles.header}>
              <span className={styles.title}>{this.props.title}</span>
              <span>
                <button
                  className={buttonStyles.closeDark}
                  onClick={this.props.onClose}
                >
                  <i className={iconStyles.iconClose} />
                </button>
              </span>
            </div>
            <div className={styles.tooltipWrapper}>
              <div className={styles.contentWrapper}>
                {this.renderContent()}
              </div>
            </div>
          </div>
        </div>
      </span>
    );
    /* eslint-enable */
  }
}

TooltipView.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  ]).isRequired,
};

export default TooltipView;



// WEBPACK FOOTER //
// ./app/components/tooltipView/index.js